export type AppLayoutName = 'default' | 'non-logged';

function removeLocalePrefix(path: string) {
  return path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
}

export function resolvePageLayout(path: string): AppLayoutName {
  const normalizedPath = removeLocalePrefix(path);
  return /^\/auth(?:\/|$)/.test(normalizedPath) ? 'non-logged' : 'default';
}
